var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2d5bcc056d50611ae0415f303e048ef032be8662"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["ef-scheduling-webapp@ef-scheduler"]={id:"2d5bcc056d50611ae0415f303e048ef032be8662"};
      